

export class comentariosAvances {
    id: number;
    descripcion: string;
    fecha: string;
    id_usuario: number;
    id_proyecto: string;
    nombreUsuario: string;
    porcentajeRegistrado: number;
    fase?: string;
    avanceDesarrollo?: number;
    qaSubFases?: any[];
    prodSubFases?: any[];
}